import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { GameConfigState } from './types'
import { KenoConfigurationAPI } from '@API/config/config'
import { DataFetchingState } from '@AppState/types'
const initialState: GameConfigState = {
  fetchState: DataFetchingState.IDLE,
  gameRules: null,
}

export const fetchGameConfig = createAsyncThunk('config/fetchData', async () => {
  const config = await KenoConfigurationAPI.fetchGameConfig()
  return config
})

export const gameConfigSlice = createSlice({
  name: 'gameConfig',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchGameConfig.fulfilled, (state, action) => {
      state.fetchState = DataFetchingState.SUCCEEDED
      state.gameRules = action.payload
    })
    builder.addCase(fetchGameConfig.pending, (state) => {
      state.fetchState = DataFetchingState.PENDING
      state.gameRules = null
    })
    builder.addCase(fetchGameConfig.rejected, (state, action) => {
      console.error(action.error)
      state.fetchState = DataFetchingState.FAILED
      state.gameRules = null
    })
  },
})

export const GameConfigReducer = gameConfigSlice.reducer
